import { createSlice } from '@reduxjs/toolkit'

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    version: '25.0929.002',
    activePage: 'START',
    backend: {
      //baseProtocol: 'http',
      baseProtocol: 'https',
      //url: 'localhost:8080' // local
      url: 'max2.ws-epic.dev' // test 
    },
    modal: {
      contract: {
        open: false,
        data: null,
        editMode: false
      },
      special: {
        open: false,
        data: null,
        editMode: false
      },
      about: {
        open: false,
        data: null,
        editMode: false
      },
      profile: {
        open: false,
        data: null
      },
      watchlist: {
        open: false,
        data: null
      },
    },
    contractId:     null,
    objectId:       null,
    user:           null,
    token:          null,
  },
  reducers: {
    setActivePage: (state, action) => {
      state.activePage = action.payload
    },

    openModal: (state, action) => {
      if (typeof action.payload.type !== 'undefined' && typeof action.payload.data !== 'undefined') {
        state.modal[action.payload.type].open = true;
        state.modal[action.payload.type].data = action.payload.data;
        if (typeof action.payload.editMode !== 'undefined') {
          state.modal[action.payload.type].editMode = action.payload.editMode;
        }
        
      } else {
        state.modal[action.payload].open = true;
      }
    },
    closeModal: (state, action) => {
      state.modal[action.payload].open = false;
      state.modal[action.payload].data = null;
    },
    setModalData: (state, action) => {
      if (typeof action.payload.type !== 'undefined' && typeof action.payload.data !== 'undefined') {
        state.modal[action.payload.type].data = action.payload.data;
      } else {
        state.modal[action.payload].data = action.payload.data;
      }
    },


    setContractId: (state, action) => {
      state.contractId = action.payload;
    }, 

    setObjectId: (state, action) => {
      state.objectId = action.payload;
    },

    setUser: (state, action) => {
      state.user = action.payload;
    },

    setToken: (state, action) => {
      state.token = action.payload;
    },
  },
})

// Action creators are generated for each case reducer function
export const { setActivePage, openModal, closeModal, setModalData, setContractId, setObjectId, setUser, setToken } = appSlice.actions

export default appSlice.reducer